<template>
  <a-modal
    :title="configData.title"
    :visible="visible"
    @ok="ok"
    @cancel="cancel"
    okText='确定'
    cancelText='取消'
    destroyOnClose 
    :maskClosable="false"
    width="600px"
  >
    <p v-for="el in configData.content" :key="el">
      {{el}}
    </p>
    <a-space slot="footer">
      <a-button v-if="configData.status === 'error'" @click='cancel'>取消</a-button>
      <a-button @click='ok' type='primary'>{{configData.status === 'success' ? '确定' : configData.status === 'error' ? '继续' : '知道了'}}</a-button>
    </a-space>
  </a-modal>
</template>


<script>
export default {
  props: ['visible','configData'],
  data() {
    return {
      content: null
    }
  },
  methods: {
    ok(){
      this.$emit('closeMsg',this.configData.status === 'error');
    },
    cancel(){
      this.$emit('closeMsg');
    }
  }
}
</script>